import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  CBadge, CCard, CCardBody, CButton, CCardHeader, CCol,
  CDataTable, CDropdown, CDropdownToggle, CDropdownMenu,
  CRow, CPagination, CModal, CModalHeader, CModalBody,
  CModalFooter, CForm, CFormGroup, CFormText, CDropdownItem,
  CLabel, CInput, CInputGroup, CInputGroupText, CImg, CButtonGroup,
} from 'compat/coreui';
import CIcon from 'compat/coreui-icon';

import { ToastContainer, toast } from 'react-toastify';

import axios from 'axios';
import moment from 'moment';



const MenuProducts = () => {
  const history = useNavigate()
  const [modal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [categoryModal, setCategoryModal] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [image, setProductImage] = useState(null);
  const [thc, setThc] = useState('');
  const [cbd, setCbd] = useState('');
  const [cbn, setCbn] = useState('');
  const [price, setPrice] = useState('');
  const [priceHalf, setPriceHalf] = useState('');
  const [priceForth, setPriceForth] = useState('');
  const [priceEight, setPriceEight] = useState('');
  const [priceOz, setPriceOz] = useState('');
  const [status, setStatus] = useState('active');
  const [preOrder, setPreOrder] = useState(1);
  const [productsData, setProductsData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [sCatId, setSelectedCat] = useState('');
  const [title, setTitle] = useState('');
  const [subTitle, setSubTitle] = useState('');
  const [editData, setEditData] = useState({});

  const toggle = () => {
    setModal(!modal);
  }

  const editToggle = () => {
    setEditModal(!editModal)
  }
  const editItem = (p) => {
    if (p) {
      setEditData(p)
    }
    editToggle()
    setSelectedCat(p._id);
  }
  const copyItem = (p) => {
    setSelectedCat(p._id);
    window.alert(
      'Are you sure to create duplicate of it',
      'alertMessage',
      [
        { text: 'Cancel', onPress: () => console.log('Cancel Pressed!') },
        { text: 'OK', onPress: copyApiCall(p._id) },
      ],
      { cancelable: false }
    )
  }

  const editMenuItem = (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    const formData = new FormData();
    // formData.append("name", name);
    formData.get('name')
    console.log('picture',formData);
    // let data = formData.append("name", values.name);
    // axios({
    //   url: `${process.env.REACT_APP_APP_API_URL}/api/editmenuitem`,
    //   method: 'POST',
    //   headers: {
    //     'Authorization': 'Bearer ' + token
    //   },
    //   data: {
    //     "itemId": editData._id,
    //     "name": name,
    //     "description": description,
    //     "image": image,
    //     "thc": thc,
    //     "cbd": cbd,
    //     "cbn": cbn,
    //     "price": price,
    //     "priceHalf": priceHalf,
    //     "priceForth": priceForth,
    //     "priceEight": priceEight,
    //     "priceOz": priceOz,
    //     "status": status,
    //     "preOrder": preOrder,
    //     "category": sCatId,
    //   }
    // }).then(response => {
    //   if (response.data.status) {
    //     getData();
    //     setTitle('');
    //     setSubTitle('');
    //     setEditModal(false);
    //     toast.success('Menu updated successfully')
    //   }
    // }).catch(console.log)
  }

  const addItem = (id) => {
    setSelectedCat(id)
    toggle()
  }
  const deleteItem = (id) => {
    setSelectedCat(id)
    window.alert(
      'Are you sure to delete',
      'alertMessage',
      [
        { text: 'Cancel', onPress: () => console.log('Cancel Pressed!') },
        { text: 'OK', onPress: deleteApiCall(id) },
      ],
      { cancelable: false }
    )
  }
  const deleteApiCall = (id) => {
    axios.get(`${process.env.REACT_APP_APP_API_URL}/api/category/remove?categoryId=` + id, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }).then(res => {
      setCategoryData(res.data.list);
    }).catch(e => console.log(e))
  }
  const copyApiCall = (id) => {
    axios.get(`${process.env.REACT_APP_APP_API_URL}/api/category/copy?categoryId=` + id, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }).then(res => {
      setCategoryData(res.data.list);
      history('/dashboard/menu-products')
    }).catch(e => console.log(e))
  }
  const cat_toggle = () => {
    setCategoryModal(!categoryModal);
  }

  useEffect(async () => {
    getData();
    getProduct();
  }, [])

  const getProduct = () => {
    axios.get(`${process.env.REACT_APP_APP_API_URL}/api/menuitem`, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }).then(res => {
      setProductsData(res.data.list);
    }).catch(e => console.log(e))
  }


  function getData() {
    axios.get(`${process.env.REACT_APP_APP_API_URL}/api/category?menu=1`, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }).then(res => {
      setCategoryData(res.data.list);
    }).catch(e => console.log(e))
  }

  const addCategory = (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    axios({
      url: `${process.env.REACT_APP_APP_API_URL}/api/category`,
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + token
      },
      data: {
        "parent": null,
        "title": title,
        "subTitle": subTitle,
        "image": null,
        "isMenu": 1,
      }
    }).then(response => {
      if (response.data.status) {
        getData();
        setTitle('');
        setSubTitle('');
        setCategoryModal(false);
      }
    }).catch(console.log)
  }


  const addProducts = (e) => {
    e.preventDefault();
    e.target.reset();
    console.log("product image", image)
    /*const data= {
        "image": productImage,
      }
      console.log(data)*/
    const token = localStorage.getItem('token');
    axios({
      url: `${process.env.REACT_APP_APP_API_URL}/api/menuitem`,
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + token
      },
      data: {
        "name": name,
        "description": description,
        "image": image,
        "thc": thc,
        "cbd": cbd,
        "cbn": cbn,
        "price": price,
        "priceHalf": priceHalf,
        "priceForth": priceForth,
        "priceEight": priceEight,
        "priceOz": priceOz,
        "status": status,
        "preOrder": preOrder,
        "category": sCatId,
      }
    }).then(response => {
      if (response.data.status) {
        setModal(false);
        getProduct();
        toast.success('Product added successfully')
      }
    }).catch(console.log)
  }
  return (
    <CRow className="menu_product_page">
      <CCol xl={12}>
        <CCard>
          <CCardHeader className="category_header">
            Menu & Products
            <div className="category_header_search">
              <CForm inline>
                <CInput
                  className="mr-sm-2"
                  placeholder="Search"
                  size="sm"
                />
              </CForm>
              <CButton
                onClick={cat_toggle}
                className="mr-1"
                color="success"
              >Add Menu</CButton>
            </div>
          </CCardHeader>
          <CCardBody>
            {categoryData.map((item, index) => {
              return (
                <div key={index}>
                  <CRow className="mt-1 pt-1 pb-1 mb-3" key={index}>
                    <CCol lg={3} className="d-flex">
                      <CInput type="checkbox" className="category-checkbox mx-4" />
                      <h4>{item.title}</h4>
                    </CCol>
                    <CCol lg={4} className="product-add-btn">
                      <span><small>TYPE: {item.subTitle}</small></span>&nbsp;
                          <span onClick={() => addItem(item._id, "add")}><i className="fa fa-plus-circle circle"></i>Add Item</span>
                      <span><i className="fa fa-pencil"></i></span>
                      <span onClick={() => deleteItem(item._id)}><i className="fa fa-times-circle"></i></span>
                    </CCol>
                    <CCol className="hideCol">g</CCol>
                    <CCol className="hideCol">1/8</CCol>
                    <CCol className="hideCol">1/4</CCol>
                    <CCol className="hideCol">1/2</CCol>
                    <CCol className="hideCol">oz</CCol>
                    <CCol lg={1} className="hideCol" />
                  </CRow>

                  {productsData.filter((product) => {
                    return product.category && product.category._id === item._id
                  }).map((p) => {
                    return (<div>
                      <CRow className="mt-2 pt-1 pb-1 menu-des">
                        <CCol lg={3} className="d-flex">
                          <CInput type="checkbox" className="category-checkbox mx-4" />
                          <span className="item-pic">
                            <i className="fa fa-camera" aria-hidden="true" style={{ paddingTop: '0.8em' }}></i>
                          </span>
                          <div className="category-menu-title">
                            <h5>{p.name}</h5>
                            <span><small>{item.title}</small></span>
                          </div>
                          <div className="menu-add-btn hide-on-desktop">
                            <span ><i className="fa fa-pencil"></i></span>
                            <span ><i className="fa fa-times-circle"></i></span>
                          </div>
                        </CCol>
                        <CCol lg={4} />
                        <CCol className="menu-price"><h6>{p.price}</h6><span>g</span></CCol>
                        <CCol className="menu-price"><h6>{p.priceEight}</h6><span>1/8</span></CCol>
                        <CCol className="menu-price"><h6>{p.priceForth}</h6><span>1/4</span></CCol>
                        <CCol className="menu-price"><h6>{p.priceHalf}</h6><span>1/2</span></CCol>
                        <CCol className="menu-price"><h6>{p.priceOz}</h6><span>oz</span></CCol>
                        <CCol lg={1} className="menu-add-btn hideCol">
                          <span onClick={() => editItem(p)}><i className="fa fa-pencil"></i></span>
                          <span onClick={() => copyItem(p)}><i className="fa fa-copy"></i></span>
                        </CCol>
                      </CRow>
                      {/*<CRow className="des-hide mt-2">
                    <CCol>
                      <h6>Item Description</h6>
                      <span>{p.description}</span>
                    </CCol>
                  </CRow>*/}
                    </div>)
                  })}
                </div>
              )
            })
            }

          </CCardBody>
        </CCard>
      </CCol>
      <CModal
        show={modal}
        onClose={toggle}
      >
        <CModalHeader closeButton>Add Products</CModalHeader>
        <CModalBody>
          <form onSubmit={addProducts}>
            <CFormGroup className="row px-4">
              <CCol xl={6} md={6} className="pl-0">
                <CLabel htmlFor="nf-title">Category *</CLabel>
                <CDropdown>
                  <select
                    className="custom-select my-1 mr-sm-2 product_status"
                    onChange={(e) => setSelectedCat(e.target.value)}
                    value={sCatId}
                  >
                    {categoryData.map((cat, index) => {
                      return (<option key={index} value={cat._id}>{cat.title}</option>);
                    })}
                  </select>
                </CDropdown>
              </CCol>
              <CCol xl={6} md={6} className="pr-0">
                <CLabel htmlFor="nf-title">Products Name *</CLabel>
                <CInput
                  type="text"
                  id="nf-name"
                  name="nf-name"
                  placeholder="Enter name.."
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
              </CCol>
            </CFormGroup>
            <CFormGroup>
              <CLabel htmlFor="nf-description">Item Description *</CLabel>
              <CInput
                type="text"
                id="nf-description"
                name="nf-description"
                placeholder="Enter description.."
                value={description}
                onChange={e => setDescription(e.target.value)}
              />
            </CFormGroup>
            <CFormGroup className="d-flex ">
              <div className="col-lg-5 pl-0">
                <CLabel htmlFor="nf-product_image">Item Photo</CLabel>
                <div className="product_wrap">
                  <div className="p_img">
                    <i className="fa fa-camera" aria-hidden="true"></i>
                  </div>
                  <div>
                    <div className="fileUpload">
                      <span>Upload a Photo</span>
                      <CInput type="file" className="upload" name="picture" onChange={(e) => setProductImage(e.target.files[0])} />
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <CLabel htmlFor="nf-product_image">Lab Tested Result</CLabel>
                <div className="d-flex">
                  <CInput type="text" name="THC" className="THC" onChange={(e) => setThc(e.target.value)} /><span style={{ padding: '5px', fontSize: '12px' }}>THC%</span>
                  <CInput type="text" name="CBD" className="CBD" onChange={(e) => setCbd(e.target.value)} /><span style={{ padding: '5px', fontSize: '12px' }}>CBD%</span>
                  <CInput type="text" name="CBN" className="CBN" onChange={(e) => setCbn(e.target.value)} /><span style={{ padding: '5px', fontSize: '12px' }}>CBN%</span>
                </div>
              </div>
            </CFormGroup>

            <CFormGroup>
              <CLabel htmlFor="nf-pricing">Pricing</CLabel>
              <div className="d-flex">
                <div className="p-1">
                  <CLabel htmlFor="nf-pricing" style={{ background: 'lightgray', padding: '3px 35px' }} >g</CLabel>
                  <CInput type="text" name="price" className="price" onChange={(e) => setPrice(e.target.value)} />
                </div>
                <div className="p-1">
                  <CLabel htmlFor="nf-pricing" style={{ background: 'lightgray', padding: '3px 35px' }}>1/8</CLabel>
                  <CInput type="text" name="priceEight" className="priceEight" onChange={(e) => setPriceEight(e.target.value)} />
                </div>
                <div className="p-1">
                  <CLabel htmlFor="nf-pricing" style={{ background: 'lightgray', padding: '3px 35px' }}>1/4</CLabel>
                  <CInput type="text" name="priceForth" className="price" onChange={(e) => setPriceForth(e.target.value)} />
                </div>
                <div className="p-1">
                  <CLabel htmlFor="nf-pricing" style={{ background: 'lightgray', padding: '3px 35px' }}>1/2</CLabel>
                  <CInput type="text" name="priceHalf" className="priceHalf" onChange={(e) => setPriceHalf(e.target.value)} />
                </div>
                <div className="p-1">
                  <CLabel htmlFor="nf-pricing" style={{ background: 'lightgray', padding: '3px 35px' }}>oz</CLabel>
                  <CInput type="text" name="priceOz" className="price" onChange={(e) => setPriceOz(e.target.value)} />
                </div>
              </div>
            </CFormGroup>
            <CFormGroup className="row px-4">
              <CCol xl={6} md={6} className="pl-0">
                <CLabel htmlFor="nf-title">Status</CLabel>
                <CDropdown>
                  <select className="custom-select my-1 mr-sm-2 product_status" onChange={(e) => setStatus(e.target.value)}>
                    <option value="active">Active</option>
                    <option value="disable">Inactive</option>
                  </select>
                </CDropdown>
              </CCol>
              <CCol xl={6} md={6} className="pr-0">
                <CLabel htmlFor="nf-title">Pre-order Online</CLabel>
                <CDropdown className="btn-lg" style={{ padding: '0px' }}>
                  <select className="custom-select my-1 mr-sm-2 product_status" onChange={(e) => setPreOrder(e.target.value)}>
                    <option value={1}>Available</option>
                    <option value={2}>Not Available</option>
                  </select>
                </CDropdown>
              </CCol>
            </CFormGroup>
            <div className="d-flex">
              <CInput type="checkbox" className="addCheckbox mr-2" />
              <CLabel htmlFor="add_another" className="mt-2">Add Another</CLabel>
            </div>
            <CButton color="primary" type="submit">Save</CButton>{' '}
            <CButton
              color="secondary"
              onClick={toggle}>
              Cancel
              </CButton>
          </form>
        </CModalBody>
      </CModal>

      <CModal
        show={categoryModal}
        onClose={cat_toggle}
      >
        <CModalHeader closeButton>Add Category</CModalHeader>
        <CModalBody>
          <form onSubmit={addCategory}>
            <CFormGroup>
              <CLabel htmlFor="nf-title">Category Name</CLabel>
              <CInput
                type="text"
                id="nf-title"
                name="nf-title"
                placeholder="Enter title.."
                value={title}
                onChange={e => setTitle(e.target.value)}
              />
              <CFormText className="help-block">Please enter category name</CFormText>
            </CFormGroup>
            <CFormGroup>
              {/* <CLabel htmlFor="nf-subtitle">Sub Category</CLabel>
              <CInput
                type="text"
                id="nf-subtitle"
                name="nf-subtitle"
                placeholder="Enter subtitle.."
                value={subTitle}
                onChange={e => setSubTitle(e.target.value)}
              /> */}
              <CLabel htmlFor="nf-title">Category Type</CLabel>
                <CDropdown>
                  <select
                    className="custom-select my-1 mr-sm-2 product_status"
                    
                  >
                    <option value="hybrid">Hybrid</option>
                    <option value="indica">Indica</option>
                    <option value="sativa">Sativa</option>
                    <option value="concentrates">Concentrates</option>
                    <option value="tincture">Tincture</option>
                    <option value="edibles">Edibles</option>
                    <option value="prerolls">Prerolls</option>
                    <option value="clones">Clones</option>
                    <option value="seeds">Seeds</option>
                    <option value="merchandise">Merchandise</option>
                    <option value="other">Other</option>
                  </select>
                </CDropdown>
              {/* <CFormText className="help-block">Please enter sub category</CFormText> */}
            </CFormGroup>
            <CButton color="primary" type="submit">Add</CButton>{' '}
            <CButton
              color="secondary"
              onClick={cat_toggle}>
              Cancel
                  </CButton>
          </form>
        </CModalBody>
      </CModal>


      <CModal
        show={editModal}
        onClose={editToggle}
      >
        <CModalHeader closeButton>Edit Menu</CModalHeader>
        <CModalBody>
          <form onSubmit={editMenuItem}>
            <CFormGroup className="row px-4">
              <CCol xl={6} md={6} className="pl-0">
                <CLabel htmlFor="nf-title">Category *</CLabel>
                <CDropdown>
                  <select
                    className="custom-select my-1 mr-sm-2 product_status"
                    onChange={(e) => setSelectedCat(e.target.value)}
                    defaultValue={sCatId}
                  >
                    {categoryData.map((cat, index) => {
                      return (<option key={index} defaultValue={cat._id}>{cat.title}</option>);
                    })}
                  </select>
                </CDropdown>
              </CCol>
              <CCol xl={6} md={6} className="pr-0">
                <CLabel htmlFor="nf-title">Products Name *</CLabel>
                <CInput
                  type="text"
                  id="nf-name"
                  name="nf-name"
                  placeholder="Enter name.."
                  defaultValue={editData.name}
                  onChange={e => setName(e.target.value)}
                />
              </CCol>
            </CFormGroup>
            <CFormGroup>
              <CLabel htmlFor="nf-description">Item Description *</CLabel>
              <CInput
                type="text"
                id="nf-description"
                name="nf-description"
                placeholder="Enter description.."
                defaultValue={editData.description}
                onChange={e => setDescription(e.target.value)}
              />
            </CFormGroup>
            <CFormGroup className="d-flex ">
              <div className="col-lg-5 pl-0">
                <CLabel htmlFor="nf-product_image">Item Photo</CLabel>
                <div className="product_wrap">
                  <div className="p_img">
                    <i className="fa fa-camera" aria-hidden="true"></i>
                  </div>
                  <div>
                    <div className="fileUpload">
                      <span>Upload a Photo</span>
                      <CInput type="file" className="upload"  name="picture" onChange={(e) => setProductImage(e.target.files[0])}/>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <CLabel htmlFor="nf-product_image">Lab Tested Result</CLabel>
                <div className="d-flex">
                  <CInput type="text" name="THC" defaultValue={editData.thc} className="THC" onChange={(e) => setThc(e.target.value)} /><span style={{ padding: '5px', fontSize: '12px' }}>THC%</span>
                  <CInput type="text" name="CBD" defaultValue={editData.cbd} className="CBD" onChange={(e) => setCbd(e.target.value)} /><span style={{ padding: '5px', fontSize: '12px' }}>CBD%</span>
                  <CInput type="text" name="CBN" defaultValue={editData.cbn} className="CBN" onChange={(e) => setCbn(e.target.value)} /><span style={{ padding: '5px', fontSize: '12px' }}>CBN%</span>
                </div>
              </div>
            </CFormGroup>

            <CFormGroup>
              <CLabel htmlFor="nf-pricing">Pricing</CLabel>
              <div className="d-flex">
                <div className="p-1">
                  <CLabel htmlFor="nf-pricing" style={{ background: 'lightgray', padding: '3px 35px' }} >g</CLabel>
                  <CInput type="text" name="price" defaultValue={editData.price} className="price" onChange={(e) => setPrice(e.target.value)} />
                </div>
                <div className="p-1">
                  <CLabel htmlFor="nf-pricing" style={{ background: 'lightgray', padding: '3px 35px' }}>1/8</CLabel>
                  <CInput type="text" name="priceEight" defaultValue={editData.priceEight} className="priceEight" onChange={(e) => setPriceEight(e.target.value)} />
                </div>
                <div className="p-1">
                  <CLabel htmlFor="nf-pricing" style={{ background: 'lightgray', padding: '3px 35px' }}>1/4</CLabel>
                  <CInput type="text" name="priceForth" defaultValue={editData.priceForth} className="priceForth" onChange={(e) => setPriceForth(e.target.value)} />
                </div>
                <div className="p-1">
                  <CLabel htmlFor="nf-pricing" style={{ background: 'lightgray', padding: '3px 35px' }}>1/2</CLabel>
                  <CInput type="text" name="priceHalf" defaultValue={editData.priceHalf} className="priceHalf" onChange={(e) => setPriceHalf(e.target.value)} />
                </div>
                <div className="p-1">
                  <CLabel htmlFor="nf-pricing" style={{ background: 'lightgray', padding: '3px 35px' }}>oz</CLabel>
                  <CInput type="text" name="priceOz" defaultValue={editData.priceOz} className="price" onChange={(e) => setPriceOz(e.target.value)} />
                </div>
              </div>
            </CFormGroup>
            <CFormGroup className="row px-4">
              <CCol xl={6} md={6} className="pl-0">
                <CLabel htmlFor="nf-title">Status</CLabel>
                <CDropdown>
                  <select className="custom-select my-1 mr-sm-2 product_status" defaultValue={editData.status} onChange={(e) => setStatus(e.target.value)}>
                    <option value="active">Active</option>
                    <option value="disable">Inactive</option>
                  </select>
                </CDropdown>
              </CCol>
              <CCol xl={6} md={6} className="pr-0">
                <CLabel htmlFor="nf-title">Pre-order Online</CLabel>
                <CDropdown className="btn-lg" style={{ padding: '0px' }}>
                  <select className="custom-select my-1 mr-sm-2 product_status" onChange={(e) => setPreOrder(e.target.value)}>
                    <option defaultValue={1}>Available</option>
                    <option defaultValue={2}>Not Available</option>
                  </select>
                </CDropdown>
              </CCol>
            </CFormGroup>
            <div className="d-flex">
              <CInput type="checkbox" className="addCheckbox mr-2" />
              <CLabel htmlFor="add_another" className="mt-2">Add Another</CLabel>
            </div>
            <CButton color="primary" type="submit">Save</CButton>{' '}
            <CButton
              color="secondary"
              onClick={editToggle}>
              Cancel
              </CButton>
          </form>
        </CModalBody>
      </CModal>
    </CRow>
  )
}

export default MenuProducts;
